import $ from 'jquery';
import cx from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Utils from 'medscape/utils';
import Reflux from 'reflux';
//import SlideActions from './slide-actions';
/*
  Renders the Notes and Links Icons
*/
export default class SlideIcons extends Reflux.Component {
  constructor(props){
    super(props);
    this.state = {};
    this.store = new SlideIconsStore(props);
  }
  
  getNotesIcon(){
    if(!this.state.showNotes){
      return;
    }
    let ButtonProps={
      isActive: this.state.isNotesVisible,
      onClick: (e) => { e.preventDefault(); this.props.SlideActions.toggleNotes(this.state.index) }
    }
    return (
      <this.props.Buttons.Notes {...ButtonProps} />
    )
  }

  getLinksIcon(){
    if(!this.state.showLinks){
      return;
    }
    let ButtonProps={
      isActive: this.state.isLinksVisible,
      onClick: (e) => { e.preventDefault(); this.props.SlideActions.toggleLinks() }
    }
    return (
      <this.props.Buttons.Links {...ButtonProps} />
    )
    
  }
  render() {
    if(this.props.slides.length==0){
      return false;
    }
    let Notes = this.getNotesIcon();
    let Links = this.getLinksIcon();

    return (
        <div className="icons-container">
          {this.getNotesIcon()}
          {this.getLinksIcon()}
        </div>
    );
  }
}

SlideIcons.propTypes={
  links: React.PropTypes.object,
  slides: React.PropTypes.array,
  SlideActions: React.PropTypes.object,
  Buttons: React.PropTypes.object
}
SlideIcons.defaultProps={
}

class SlideIconsStore extends Reflux.Store
{
    constructor(props)
    {
        super();
        this.props = props;
        this.state = this.getInitialState();
        this.listenables = props.SlideActions;
    }
    getInitialState(index=0){
        const slide = this.props.slides[index];
        return {
            index: index,
            showLinks: this.props.links.content.length>0,
            showNotes: slide.notes.content.length>0,
            isLinksVisible: false,
            isNotesVisible: false
        }
    }

    afterChange(index){
        const slide = this.props.slides[index];
        this.setState(this.getInitialState(index))
        //this.setState(this.getInitialState());
    }
    beforeChange(currIndex,nextIndex){
    }
    onToggleNotes(index,flag = !this.state.isNotesVisible){
        this.setState({
          isNotesVisible: flag,
          isLinksVisible: false
        })
    }
    onToggleLinks(flag = !this.state.isLinksVisible){
        this.setState({
            isNotesVisible: false,
            isLinksVisible: flag
        })
    }
    
}


// WEBPACK FOOTER //
// ./src/app/carousel/slide-icons.jsx